import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=34b2ef6b&scoped=true"
import script from "./Exception.vue?vue&type=script&lang=js"
export * from "./Exception.vue?vue&type=script&lang=js"
import style0 from "./Exception.vue?vue&type=style&index=0&id=34b2ef6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b2ef6b",
  null
  
)

export default component.exports